import {
  IconButton,
  Box,
  Backdrop,
  Drawer,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useUserStore } from '../../store';
import { useResponsive } from '../../hooks/useResponsive';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { MenuUserAvatar } from '../MenuAppBar/MenuAppBar.styles';
import URLs from '../../pages/URLs';
import { Link } from 'react-router-dom';
import { generatePath } from 'react-router';
import { isDevMode } from '../../utils/isDevMode';

export const HamburgerMenu = () => {
  const { isMobile } = useResponsive();
  const { user } = useUserStore();

  const [open, setOpen] = useState(false);

  const toggleDrawer = (state: boolean) => () => {
    setOpen(state);
  };

  const menuItems = [
    { label: 'Home', link: '/' },
    { label: 'SDP Dashboard', link: URLs.SdpDashboard },
    isDevMode() ? { label: 'SDP Summary Dashboard', link: URLs.SdpSummaryDashboard } : null,
    { label: 'Salon Dashboard', link: generatePath(URLs.SalonDashboard, { salonId: '' }) },
    isDevMode() ? { label: 'Leadership Dashboard', link: URLs.LeadershipDashboard } : null,
  ];

  return (
    <>
      <IconButton
        edge="start"
        color="inherit"
        onClick={toggleDrawer(true)}
        sx={{ marginRight: '8px' }}
      >
        <MenuIcon fontSize="large"></MenuIcon>
      </IconButton>

      <Backdrop
        open={open}
        onClick={toggleDrawer(false)}
        sx={{
          backdropFilter: 'blur(2px)',
          backgroundColor: 'rgba(0, 0, 0, 0.03)',
          zIndex: (theme) => theme.zIndex.drawer - 1,
        }}
      />

      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: { width: isMobile ? '90%' : '10%', minWidth: 360, maxWidth: 440 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <IconButton onClick={toggleDrawer(false)}>
            <CloseIcon fontSize="medium" />
          </IconButton>
        </Box>
        <Box px={2} pb={1}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MenuUserAvatar alt={user?.sourceName} src={'#'} />

            <Box>
              <Typography variant="subtitle1" fontWeight={500}>
                {user?.firstName ? user.firstName + ' ' + user.lastName : user?.sourceName || ''}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {user?.roles
                  .filter((item) => item !== 'authenticated')
                  .join(', ')
                  .toUpperCase()}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Divider />

        <List>
          {menuItems.map((item) => {
            return item ? (
              <ListItemButton
                key={item.label}
                component={Link}
                to={item.link}
                onClick={toggleDrawer(false)}
              >
                <ListItemIcon>
                  <FavoriteIcon />
                </ListItemIcon>

                <ListItemText primary={item.label} />
              </ListItemButton>
            ) : null;
          })}
        </List>
      </Drawer>
    </>
  );
};
